"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateNewAdventure = void 0;
const constants_1 = require("../../../constants");
const types_1 = require("../../../types");
const weeksToAdventureTimestamp_1 = require("./weeksToAdventureTimestamp");
const anchor_1 = require("@project-serum/anchor");
const generateNewAdventure = ({ weeks, lowerRewardsLimit, upperRewardsLimit, programId, }) => __awaiter(void 0, void 0, void 0, function* () {
    const adventureTimestamp = (0, weeksToAdventureTimestamp_1.weeksToAdventureTimestamp)(weeks);
    const [adventure] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.ADVENTURE_PREFIX), constants_1.ENCODER.encode(adventureTimestamp.toString())], programId);
    return {
        adventureState: types_1.AdventureState.Uninitialized,
        periodStartedAt: adventureTimestamp,
        periodEndingAt: adventureTimestamp + constants_1.ADVENTURE_DURATION,
        rewardsUpperLimit: upperRewardsLimit,
        rewardsLowerLimit: lowerRewardsLimit,
        totalPeriodRevenue: 0,
        rewardsToBeDistributed: 0,
        totalBanxSubscribed: 0,
        totalPartnerPoints: 0,
        totalPlayerPoints: 0,
        banxSubscribedLeft: 0,
        partnerPointsLeft: 0,
        playerPointsLeft: 0,
        rewardsLeft: 0,
        publicKey: adventure.toBase58(),
    };
});
exports.generateNewAdventure = generateNewAdventure;
